import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { SummaryDivider } from '../../../steps/components/ConfigurationSummaryDivider/ConfigurationSummaryDivider.js';
import PrescriptionSummaryContainer from '../../../steps/components/PrescriptionSummary/PrescriptionSummaryContainer.js';
import { PrescriptionUploadSummaryContainer } from '../../../steps/components/PrescriptionUploadSummary/PrescriptionUploadSummaryContainer.js';
import { isNewPrescriptionAndUpload } from '../../../utils/is-new-prescription-upload.js';
import ConfigurationSummaryContainer from '../ConfigurationSummary/ConfigurationSummaryContainer.js';

const RxGlassesExpanderContent = ({ prescriptionType , hasVisitedStepPrescription  })=>/*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content__summary"
    }, /*#__PURE__*/ React.createElement(ConfigurationSummaryContainer, null)), !hasVisitedStepPrescription ? null : /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content__prescription"
    }, isNewPrescriptionAndUpload(prescriptionType) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, null), /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, {
        className: "prescription-upload-summary__with-overview",
        title: "products.glasses.configurator.footer.upload.title",
        hideDividers: true
    }), /*#__PURE__*/ React.createElement(SummaryDivider, null)) : CommerceToolsApi.isPrescriptionFile(prescriptionType) ? /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, null) : /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, null)))
;

export { RxGlassesExpanderContent };
//# sourceMappingURL=RxGlassesExpanderContent.js.map
